import { useLayoutEffect, useRef, useState } from "react";
import { delayNavigation } from "../helpers/helpers";

const ApartmentPath = ({
  d,
  apartment,
  dispatch,
  navigate,
  selectedProject,
  floorId,
  hoveredFlat,
  setHoveredFlat,
}) => {
  const pathRef = useRef(null);
  const [center, setCenter] = useState({ x: 0, y: 0 });

    useLayoutEffect(() => {
    if (!pathRef.current) return;

    // დაელოდოს layout-ს
    requestAnimationFrame(() => {
      const bbox = pathRef.current.getBBox();
      setCenter({
        x: bbox.x + bbox.width / 2,
        y: bbox.y + bbox.height / 2,
      });
    });
  }, [d, floorId, apartment]); 
  

  return (
    <g>
      <path
        ref={pathRef}
        d={d}
        fill={
                      apartment.isSold
                        ? "rgba(237, 60, 17, 0.3)"
                        : hoveredFlat?.number === apartment.number
                        ? "rgba(210, 242, 155, 0.5)"
                        : "transparent"
                    }
        stroke="red"
        strokeWidth="0"
        className={`${
          apartment.isSold ? "cursor-not-allowed" : "cursor-pointer"
        } pointer-events-auto transition-all duration-300`}
        onMouseEnter={() => setHoveredFlat(apartment)}
        onMouseLeave={() => setHoveredFlat(null)}
        onClick={() => {
          if (!apartment.isSold) {
            delayNavigation(
              dispatch,
              navigate,
              `/projects/${selectedProject.name}/apartments/floor/${floorId}/apartment/${apartment.number}`
            );
          }
        }}
      />

      {apartment.isSold && center.x !== 0 && center.y !== 0 && (
  <text
    x={center.x}
    y={center.y}
    textAnchor="middle"
    alignmentBaseline="middle"
    fill="red"
    fontSize="22"
    fontWeight="bold"
    transform={`rotate(-45 ${center.x} ${center.y})`}
    pointerEvents="none"
  >
    SOLD OUT
  </text>
)}
    </g>
  );
};

export default ApartmentPath;